import styled from 'styled-components'
import { css } from '@styled-system/css'

import Text from './Text'

const H2 = styled(Text)(
  css({
    fontSize: ['24px', '24px', '32px'],
    fontFamily: 'Proxima-Nova',
    letterSpacing: ['-0.72px', '-0.96px'],
    lineHeight: ['135%', '125%'],
    fontWeight: 600,
    textTransform: 'uppercase'
  })
)

H2.defaultProps = {
  as: 'h2'
}

export default H2
